import { FC } from "react";
import { Center } from "@chakra-ui/react";
import { RefetchOptions } from "@tanstack/react-query";

import { ErrorComponent } from "../../../Errors";

interface Props {
  error: Error | null;
  refetch?: (options?: RefetchOptions | undefined) => Promise<unknown>;
}

export const ProfilePageMainInfoError: FC<Props> = ({ error, refetch }) => {
  return (
    <Center flex="1">
      <ErrorComponent
        error={error}
        refetch={refetch}
      />
    </Center>
  );
};
